<template>
  <div class="banner-wrap">
    <div class="text" id="title1"></div>
    <div class="text text2" id="title2"></div>
  </div>
</template>
<script>
export default {
  props: {
    bannerShow: {
      typpe: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  watch: {
    bannerShow(newVal, oldVal) {
      console.log(newVal, oldVal);
      setTimeout(() => {
        new this.Typed('#title1', {
          strings: ['从创意到技术'],
          typeSpeed: 100,
        });
        new this.Typed('#title2', {
          strings: ['打造行业技术标杆'],
          typeSpeed: 100,
        });
      }, 1000);
    },
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
@import url('./index.scss');
</style>
